import { useEffect, useState } from 'react';
import { NodeAvatar } from './NodeAvatar';
import { useNodeLogo } from '../../hooks/use_node_logo';

/**
 * This node's logo, `size` px tall: the image a superadmin uploaded
 * (Node settings → Branding), or the node's generated avatar until then.
 * If the uploaded image fails to load (bucket moved, object deleted) it
 * drops to the generated one rather than showing a broken image.
 */
export function NodeLogo({ size = 20, className, style, onClick }) {
    const { logoUrl, nodeKey, avatar, logoAlt } = useNodeLogo();
    const [broken, setBroken] = useState(false);
    useEffect(() => { setBroken(false); }, [logoUrl]);

    if (logoUrl && !broken) {
        return (
            <img
                src={logoUrl}
                alt={logoAlt}
                className={className}
                style={{ height: size, width: 'auto', ...style }}
                onClick={onClick}
                onError={() => setBroken(true)}
            />
        );
    }
    return (
        <NodeAvatar
            serverId={nodeKey}
            avatar={avatar}
            size={size}
            className={className}
            style={{ cursor: onClick ? 'pointer' : undefined, ...style }}
            {...(onClick ? { onClick } : {})}
        />
    );
}

export default NodeLogo;
